import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json'
import { Box, getColoursFromTheme, Stack } from 'src/viewLayer/components/DesignSystem'
import { getThemeDefaultProps } from 'src/viewLayer/styling/helpers'
import devices from 'src/viewLayer/styling/mixins/mediaQueries'
import styled from 'styled-components'

const CardLayout = styled(Box)`
  background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.foregroundColor};
  margin: 0 auto;
  max-width: 28.75rem;

  @media only screen and ${devices.fromxsmall} {
    background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.backgroundColor};
    max-width: '28.75rem';
  }

  @media only screen and ${devices.fromsmall} {
    background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.backgroundColor};
  }
`

const Card = styled(Box)`
  background-color: ${({ theme }) =>
    getColoursFromTheme(theme).authContainer.loginContainer.backgroundColor};
  height: 100%;
  min-height: calc(100% - 4rem);
  position: relative;

  @media only screen and ${devices.fromsmall} {
    border-radius: 0 ${tokens.size.radius.large} ${tokens.size.radius.large}
      ${tokens.size.radius.large};
    margin: 2rem auto;
    width: '28.75rem';
  }
`

const LoginBusinessPageWithBackground = styled.div`
  background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.foregroundColor};
  height: max-content;
  min-height: 100%;
  position: absolute;
  width: 100%;
  @media only screen and ${devices.fromsmall} {
    background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.backgroundColor};
  }
`

const FormContainer = styled(Stack)`
  margin: auto 0;
  width: 100%;
`

CardLayout.defaultProps = getThemeDefaultProps()
Card.defaultProps = getThemeDefaultProps()
LoginBusinessPageWithBackground.defaultProps = getThemeDefaultProps()

export { Card, CardLayout, FormContainer, LoginBusinessPageWithBackground }
